export const ORDER_CLINICAL_PROVIDER_SEARCH_CACHE_KEY = "order-clinical-provider-search";
export const ORDER_PPN_RECOMMENDATIONS_CACHE_KEY = "order-ppn-recommendations";
export const ORDER_PPN_SEARCH_CACHE_KEY = "order-ppn-search";
export const ORDER_STEDI_ELIGIBILITY_CHECK_CACHE_KEY = "order-stedi-eligibility-check";
export const ORDER_PATIENT_CASE_SYNC_CACHE_KEY = "order-patient-case-sync";
export const PAGINATED_ORDERS_CACHE_KEY = "paginated-orders";
export const SINGLE_ORDER_CACHE_KEY = "single-order";
export const SIBLING_ORDERS_CACHE_KEY = "sibling-orders";
